import { string } from '@amcharts/amcharts4/core';
import { CommonService } from './../../../shared/services/common.service';
import { BankTranactionModel } from './../../models/bankTranactionModel';

import { first } from 'rxjs/operators';
import { PurchaseService } from './../../services/purchase.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, Form, NgForm } from '@angular/forms';
import { AccountService } from '../../../account/services/account.service';
import { ResellerInfoModel } from '../../../account/models/profile/reellerInfoModel';
import { throwError, Subscription } from 'rxjs';
import { DialogBoxComponent } from '../../../shared/dialog/dialog-box/dialog-box.component';
import { MatDialog, MatStepper } from '@angular/material';
import { Location } from '@angular/common';
import { BulkProductModel } from '../../models/bulkProductModel';
import { BulkProductPriceModel } from '../../models/bulkProductPriceModel';
import { MassPurchaseOrderModel } from '../../models/massPurchaseOrderModel';
import { OrderInfoModel } from '../../models/orderInfoModel';
import { OrderInfoItems } from '../../models/orderInfoItems';
import { ContactInfoModel } from '../../../shared/models/contactInfoModel';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-mass-purchase',
  templateUrl: './mass-purchase.component.html',
  styleUrls: ['./mass-purchase.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MassPurchaseComponent implements OnInit {
  @ViewChild('stepper') stepper: MatStepper;
  //موقع ساخت سفارش
  loading = false;
  //موقع ارسال به صفحه بانک
  bankPaymentLoading = false;
  //دکمه خرید
  disabled = false;
  //نمایش خطا 
  showMessage = null;

  disabledPaymentSubmited = true;
  sellerInfo: ResellerInfoModel = new ResellerInfoModel();
  products: BulkProductModel = new BulkProductModel();
  selectedProduct: BulkProductPriceModel = new BulkProductPriceModel();
  purchaseFormGroup: FormGroup;
  contactInfoModel: ContactInfoModel = new ContactInfoModel();
  orderId: string = null;
  orderErrorMessage: string = null;
  currentOrder: OrderInfoModel = new OrderInfoModel();
  currentOrderItem: OrderInfoItems = new OrderInfoItems();
  bankTranactionModel: BankTranactionModel = new BankTranactionModel();
  bankorderId: string;
  bankTransactionId: string;
  getWay: number;
  getWayName: string;
  paymentErrorMessage: string = null;
  orderLoading: boolean = false; //لود سفارش
  productListLoading = true;
  complateActionLabel: string = "اتمام خرید";
  hasDiscount:boolean=false;
  private routerParmsSub: Subscription;
  constructor(
    private _formBuilder: FormBuilder,
    private accountService: AccountService,
    private purchaseService: PurchaseService,
    private changeDetectorRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private location: Location,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private http: HttpClient
  ) { }

  ngOnInit() {
    this.routerParmsSub = this.route.params.subscribe(params => {
      if (this.route.snapshot.queryParamMap.get('bankorderId') &&
        this.route.snapshot.queryParamMap.get('bankTransactionId')) {
        this.bankorderId = this.route.snapshot.queryParamMap.get('bankorderId');
        this.bankTransactionId = this.route.snapshot.queryParamMap.get('bankTransactionId');
        this.stepper.selectedIndex = 3; //رفتن به آخرین صفحه و نمایش پیغام موفقیت آمیز بودن
      } else if (this.route.snapshot.queryParamMap.get('msg')) {
        this.paymentErrorMessage = this.route.snapshot.queryParamMap.get('msg');
        this.stepper.selectedIndex = 3; //رفتن به آخرین صفحه و نمایش پیغام خطا
        this.complateActionLabel = "خرید ناتمام"
      }
      this.initializePurchasePostForm();
      this.loadProducts();
      this.loadContractInfo();

    }, err => { });
  }


  loadProducts() {
    this.purchaseService.getBulkProductsForReseller(1).subscribe((res: BulkProductModel) => {
      this.productListLoading = false;
      this.products = res;
      this.selectedProduct = this.products.prices[0];
      this.hasDiscount=this.selectedProduct.price<this.selectedProduct.displayPrice;
      this.changeDetectorRef.markForCheck();
    });
  }

  loadContractInfo() {
    this.commonService.getContactInfo().subscribe((res: ContactInfoModel) => {
      this.contactInfoModel = res;
      this.changeDetectorRef.markForCheck();
    });
  }

  initializePurchasePostForm() {
    this.purchaseFormGroup = this._formBuilder.group({
      selectedProductType: ['', Validators.compose([
        Validators.required
      ])
      ]
    });
  }

  async selectProductSubmit() {
    const controls = this.purchaseFormGroup.controls;

    // check form
    if (this.purchaseFormGroup.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }
    this.showMessage = null;
    var model = new MassPurchaseOrderModel();
    model.priceId = this.selectedProduct.id;
    model.customerContact = this.contactInfoModel.phoneNumber;
    model.productId = 1;
    model.orderCount = 1;
    model.discountCode = null;
    this.loading = true;
    this.disabled = true;

    await this.purchaseService.createMassPurchaseOrder(model).toPromise().then((res: number) => {

      if (res <= 0) {
        this.loading = false;
        this.disabled = false;
        return;
      }
      this.orderId = res['orderId'];
      this.stepper.next();
      window.scroll(0, 0); //scroll to top
      this.loading = false;
      this.disabled = false;
      this.changeDetectorRef.markForCheck();
    }, (err) => {
      this.loading = false;
      this.disabled = false;
      this.orderErrorMessage = err.error.result;
      this.changeDetectorRef.markForCheck();
    });

    this.orderLoading = true;
    await this.purchaseService.getMassPurchaseOrder(this.orderId).toPromise().then((res: OrderInfoModel) => {
      this.currentOrder = res;
      this.orderLoading = false;
      this.currentOrderItem = this.currentOrder.orderItems[0];
      this.getWay = this.currentOrderItem.defaultGateway;
      this.getWayName = this.getBankName(this.getWay);
      this.disabledPaymentSubmited = false;//فعال کردن دکمه ارسال به صفحه بانک
      this.changeDetectorRef.markForCheck();
    });

  }

  changeGetWay(value: number) {
    this.getWay = value;
    this.getWayName = this.getBankName(this.getWay);
  }

  getBankName(id: number): string {
    if (id == 1) return "پارسیان";
    if (id == 2) return "ملت";

    if (id == 3) return "زرین پال";
    if (id == 4) return "زرین پال";
  }

  getBankNameId(id: number): string {
    if (id == 1) return "parsian";
    if (id == 2) return "melat";

    if (id == 3) return "zarinpal1";
    if (id == 4) return "zarinpal2";
  }





  backClick() {
    this.stepper.previous();
  }
  bankPaymentClick() {
    if (!this.getWay || this.getWay == null) {
      this.showMessage = "لطفا درگاه پرداخت را انتخاب نمائید";
      return;
    }
    this.disabledPaymentSubmited = true; //غیر فعال می کند تا کاربر دو بار کلیک نکند
    this.bankPaymentLoading = true;
    this.purchaseService.doBankPayment(this.currentOrder.orderId, this.getBankNameId(this.getWay))
      .subscribe((res: BankTranactionModel) => {
        this.bankTranactionModel = res;

        this.changeDetectorRef.markForCheck();
        this.postRefId(res.refId, res.sendToBankUrl, res.sendMethod)
        this.bankPaymentLoading = false;
      }, err => {
        window.scrollTo(0, 0);
        this.showMessage = err.error['result'];
        this.bankPaymentLoading = false;
        this.disabledPaymentSubmited = false;
        this.changeDetectorRef.markForCheck();

      }, () => {
        this.changeDetectorRef.markForCheck();
        this.bankPaymentLoading = false;
      });
  }

  postRefId(refIdValue: string, bankUrl: string, sendMethod: string) {

    try {
      if (sendMethod.toLowerCase() === 'get') {
        window.location.href = bankUrl;
        return false;
      }
      var form = document.createElement("form");
      form.setAttribute("method",sendMethod);
      form.setAttribute("action", bankUrl);
      form.setAttribute("target", "_self");
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("name", "RefId");
      hiddenField.setAttribute("value", refIdValue);
      form.appendChild(hiddenField);
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    } catch (er) {
      throwError(er);
      console.error(er);
      this.bankPaymentLoading = false;
      this.disabledPaymentSubmited = false;
      this.showMessage = "خطا در ارسال به بانک پذیرنده";
      this.changeDetectorRef.markForCheck();
    }

  }

  backStepper3() {
    this.orderId = null;
    this.bankPaymentLoading = false;
    this.stepper.previous();
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.purchaseFormGroup.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  changeProduct() {
    this.hasDiscount=this.selectedProduct.price<this.selectedProduct.displayPrice;
  }

}
